import Vue from 'vue'
import Router from 'vue-router'

import Login from '../views/login'
import Index from '../views/index'
import Error from '../views/404'
import RealTime from '../views/realTime'
import History from '../views/report/history'
import HistoryDown from '../views/report/historyDown'
import SetPwd from '../views/setPwd'

import Home from '../views/home'
import Healthy from '../views/healthy'

import Device from '../views/system/device'
import DeviceDown from '../views/system/deviceDown'
import DeviceList from '../views/system/deviceList'
import noMatch from '../views/system/noMatch'
import Tower from '../views/system/tower'
import User from '../views/system/user'
import PushLog from '../views/system/pushLog'

import Test from '../views/test'
import Report from '../views/report'
import ReportMobile from '../views/reportMobile'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      component: Index,
      redirect: '/real-time',
      children: [{
        path: '/home',
        component: Home,
        name: 'Home'
      }, {
        path: '/real-time',
        component: RealTime,
        name: 'RealTime'
      }, {
        path: '/history',
        component: History,
        name: 'History'
      }, {
        path: '/history-down',
        component: HistoryDown,
        name: 'HistoryDown'
      }, {
        path: '/healthy',
        component: Healthy,
        name: 'Healthy'
      }, {
        path: '/set-pwd',
        component: SetPwd,
        name: 'SetPwd'
      }, {
        path: '/system/device',
        component: Device,
        name: 'Device'
      }, {
        path: '/system/device-down',
        component: DeviceDown,
        name: 'DeviceDown'
      }, {
        path: '/system/deviceList',
        component: DeviceList,
        name: 'DeviceList'
      }, {
        path: '/system/noMatch',
        component: noMatch,
        name: 'noMatch'
      }, {
        path: '/system/tower',
        component: Tower,
        name: 'Tower'
      }, {
        path: '/system/user',
        component: User,
        name: 'User'
      }, {
        path: '/system/push-log',
        component: PushLog,
        name: 'PushLog'
      }, {
        path: '/404',
        component: Error,
        name: 'Error'
      }]
    },
    {
      path: '*',
      redirect: '/404',
      component: Error
    },
    {
      path: '/test',
      name: 'Test',
      component: Test
    },
    {
      path: '/report',
      name: 'Report',
      component: Report
    },
    {
      path: '/report-mobile',
      name: 'ReportMobile',
      component: ReportMobile
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js